export default __webpack_public_path__ + "static/hero-5629f58a2fd0ef15b241f797f74c7e09.jpg";